import React from 'react';
import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import Client1Logo from '../assets/Viruksh-logo.jpg';
import Client2Logo from '../assets/Infovie-Logo.png';
import Client3Logo from '../assets/neweastindia-logo.png';

const clients = [
  { name: 'Viruksh', logo: Client1Logo },
  { name: 'Infovie', logo: Client2Logo },
  { name: 'New East India Company', logo: Client3Logo },
];

const Clients = () => {
  return (
    <Box component="section" sx={{ py: { xs: 7, md: 10 }, backgroundColor: '#f5f8fc' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', mb: 5 }}>
          <Typography variant="h3" component="h2">
            Our Clients
          </Typography>
          <Typography sx={{ color: 'text.secondary', mt: 2 }}>
            Trusted by organizations building thoughtful digital experiences.
          </Typography>
        </Box>
        <Grid container spacing={3} justifyContent="center">
          {clients.map((client) => (
            <Grid item xs={12} sm={6} md={4} key={client.name}>
              <Card
                sx={{
                  height: '100%',
                  border: '1px solid rgba(15, 47, 95, 0.08)',
                  boxShadow: '0 18px 45px rgba(16, 32, 51, 0.06)',
                }}
              >
                <CardContent sx={{ p: 4, textAlign: 'center' }}>
                  <Box
                    component="img"
                    src={client.logo}
                    alt={`${client.name} logo`}
                    sx={{
                      width: 160,
                      height: 120,
                      objectFit: 'contain',
                      mx: 'auto',
                      display: 'block',
                    }}
                  />
                  <Typography variant="h6" sx={{ mt: 2 }}>
                    {client.name}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default Clients;
